import type { LatestNotice, MyMailbox } from '../types';

/** Mailboxes with mail first (most unread first), then the rest by address. */
export const byUnread = (boxes: MyMailbox[]): MyMailbox[] =>
  [...boxes].sort((a, b) => (b.unread ?? -1) - (a.unread ?? -1) || a.address.localeCompare(b.address));

/** "99+" above 99. */
export const badgeText = (n: number): string => (n > 99 ? '99+' : String(n));

/** A notice is shown as a pop-up when it is new to this browser and recent (an old one is not news). */
export const shouldPopUp = (notice: LatestNotice | null, lastShownId: string | null, now: number, maxAgeMs = 15 * 60_000): boolean => {
  if (!notice || notice.id === lastShownId) return false;
  const sent = notice.sentAt ? Date.parse(notice.sentAt) : NaN;
  return !Number.isNaN(sent) && now - sent <= maxAgeMs;
};

/** Per user, so two people on one computer do not hide each other's notices. */
export const shownKey = (userName: string | null | undefined) => `mail-unread-notice:${(userName ?? '').toLowerCase()}`;
